import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ContatoPage() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    assunto: '',
    mensagem: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formBody = new URLSearchParams();
    Object.entries(formData).forEach(([key, value]) => {
      formBody.append(key, value);
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d63mn7dsi3r5mpi9v1c0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          assunto: '',
          mensagem: '',
        });
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="bg-white py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h1 className="text-6xl font-bold text-black mb-6">Entre em contato</h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Estamos aqui para responder suas dúvidas e ajudar você a entender como investir com a Bravia Group.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              <div>
                <h2 className="text-3xl font-bold text-black mb-8">Informações de contato</h2>
                
                <div className="space-y-8 mb-12">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-map-pin-line text-xl text-black"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-black mb-1">Localização</h3>
                      <p className="text-gray-700">Winter Garden Florida<br />United States</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-phone-line text-xl text-black"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-black mb-1">Telefone</h3>
                      <p className="text-gray-700">+1 (689) 296-0820</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-mail-line text-xl text-black"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-black mb-1">Email</h3>
                      <p className="text-gray-700">contato@braviagroup.com</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-time-line text-xl text-black"></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-black mb-1">Horário de atendimento</h3>
                      <p className="text-gray-700">
                        Segunda a Sexta: 9h às 18h (EST)<br />
                        Sábado: 10h às 14h (EST)
                      </p>
                    </div>
                  </div>
                </div>

                <a
                  href="https://wa.me/5511999999999"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-8 py-4 bg-green-500 text-white rounded-full font-semibold hover:bg-green-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-2xl mr-3"></i>
                  Falar no WhatsApp
                </a>
              </div>

              <div>
                {submitSuccess ? (
                  <div className="bg-green-50 border-2 border-green-500 rounded-2xl p-12 text-center">
                    <i className="ri-checkbox-circle-line text-6xl text-green-500 mb-4"></i>
                    <h3 className="text-2xl font-bold text-black mb-2">Mensagem enviada!</h3>
                    <p className="text-lg text-gray-700">Recebemos sua mensagem e entraremos em contato em breve.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="bg-beige-50 rounded-2xl p-10" data-readdy-form id="contato-form">
                    <h2 className="text-2xl font-bold text-black mb-6">Envie uma mensagem</h2>
                    
                    <div className="space-y-6">
                      <div>
                        <label htmlFor="nome" className="block text-sm font-semibold text-gray-900 mb-2">
                          Nome completo *
                        </label>
                        <input
                          type="text"
                          id="nome"
                          name="nome"
                          required
                          value={formData.nome}
                          onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base bg-white"
                        />
                      </div>

                      <div>
                        <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                          Email *
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          value={formData.email}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base bg-white"
                        />
                      </div>

                      <div>
                        <label htmlFor="telefone" className="block text-sm font-semibold text-gray-900 mb-2">
                          Telefone
                        </label>
                        <input
                          type="tel"
                          id="telefone"
                          name="telefone"
                          value={formData.telefone}
                          onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base bg-white"
                        />
                      </div>

                      <div>
                        <label htmlFor="assunto" className="block text-sm font-semibold text-gray-900 mb-2">
                          Assunto *
                        </label>
                        <select
                          id="assunto"
                          name="assunto"
                          required
                          value={formData.assunto}
                          onChange={(e) => setFormData({ ...formData, assunto: e.target.value })}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base bg-white"
                        >
                          <option value="">Selecione um assunto</option>
                          <option value="Informações sobre investimento">Informações sobre investimento</option>
                          <option value="Dúvidas sobre projetos">Dúvidas sobre projetos</option>
                          <option value="Agendar visita">Agendar visita</option>
                          <option value="Parceria">Parceria</option>
                          <option value="Outro">Outro</option>
                        </select>
                      </div>

                      <div>
                        <label htmlFor="mensagem" className="block text-sm font-semibold text-gray-900 mb-2">
                          Mensagem *
                        </label>
                        <textarea
                          id="mensagem"
                          name="mensagem"
                          rows={5}
                          maxLength={500}
                          required
                          value={formData.mensagem}
                          onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base resize-none bg-white"
                          placeholder="Como podemos ajudar?"
                        ></textarea>
                        <p className="text-sm text-gray-500 mt-1">{formData.mensagem.length}/500 caracteres</p>
                      </div>

                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full py-4 bg-black text-white rounded-full font-semibold text-lg hover:bg-gray-800 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                      >
                        {isSubmitting ? 'Enviando...' : 'Enviar mensagem'}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
